import React from "react";

function Icon({color = '#F8FAF9', ...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      fill="none"
      viewBox="0 0 27 28"
      {...props}
    >
      <path
        fill={color}
        d="M15.326.792A13.337 13.337 0 008.17 26.227a10.343 10.343 0 01.217-3.058c.247-1.118 1.728-7.284 1.728-7.284a4.986 4.986 0 01-.432-2.102c0-1.98 1.143-3.458 2.564-3.458a1.78 1.78 0 011.79 2.01c0 1.2-.771 3.017-1.174 4.72a2.058 2.058 0 002.1 2.565c2.531 0 4.227-3.241 4.227-7.068 0-2.933-1.943-5.13-5.524-5.13a6.328 6.328 0 00-6.573 6.391 3.946 3.946 0 00.864 2.627.64.64 0 01.216.739c-.062.245-.216.83-.278 1.045a.473.473 0 01-.68.339c-1.845-.74-2.714-2.77-2.714-5.088 0-3.796 3.178-8.34 9.538-8.34 5.062 0 8.427 3.702 8.427 7.662 0 5.212-2.903 9.13-7.192 9.13a3.815 3.815 0 01-3.272-1.66s-.77 3.088-.923 3.672a10.702 10.702 0 01-1.358 2.84c1.23.374 2.509.56 3.794.556a13.317 13.317 0 0013.328-13.338A13.336 13.336 0 0015.33.793l-.003-.001z"
      ></path>
    </svg>
  );
}

export default Icon;
